import { z } from 'zod';

export const DropdownOptionsSchema = z.object({
  id: z.number(),
  domain: z.string(),
  key: z.string(),
  value: z.string(),
  description: z.string(),
  created_at: z.coerce.date(),
});

export const DropdownOptionsResponseSchema = z.array(
  z.record(z.string(), z.array(DropdownOptionsSchema))
);

export type DropdownOptions = z.infer<typeof DropdownOptionsSchema>;
export type DropdownOptionsResponse = z.infer<
  typeof DropdownOptionsResponseSchema
>;
